import { useState, useLayoutEffect, RefObject } from 'react';
import { Placement } from '@popperjs/core';

const OPTION_HEIGHT = 40;
const DROPDOWN_MAX_HEIGHT = 272;
const FOOTER_BUFFER = 80;

export const useDropdownPlacement = (
  triggerRef: RefObject<HTMLElement | null>,
  optionsCount: number = 7
): Placement => {
  const [placement, setPlacement] = useState<Placement>('bottom-start');

  useLayoutEffect(() => {
    if (!triggerRef.current) return;

    const triggerRect = triggerRef.current.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const spaceBelow = viewportHeight - triggerRect.bottom - FOOTER_BUFFER;

    const expectedHeight = Math.min(
      optionsCount * OPTION_HEIGHT,
      DROPDOWN_MAX_HEIGHT
    );

    const newPlacement: Placement =
      spaceBelow < expectedHeight ? 'top-start' : 'bottom-start';

    setPlacement(newPlacement);
  }, [triggerRef, optionsCount]);

  return placement;
};
